module.exports = __webpack_public_path__ + "static/preview_image-bd7737e24b6b981a6c5bf605c56c57ed.png";